import { CampaignConfigDto, DiscountDto } from '@coretava/api/ecommerce-service';
import { calculateBoosterEndDate, formatDiscountValue } from '@gamiphy/loyalty-station-desktop/components/cashback/utils';
import { Trans } from '@gamiphy/react-i18n';
import { formatDate } from '@gamiphy/utils/date';
import { Stack, Typography } from '@mui/material';
import React from 'react';

const ReferrerCongrats: React.FC<{campaign: CampaignConfigDto, discount: DiscountDto}> = ({ campaign, discount }) => (
  <Stack spacing={2}>
    <Typography fontSize={14} fontWeight={600}>
      <Trans
        i18nKey="campaigns.boosters.referral.widget.congrats"
        defaults="Congratulations! 🎉"
      />
    </Typography>
    <Typography fontSize={14}>
      <Trans
        i18nKey="campaigns.boosters.referral.widget.congrats.info"
        defaults="Your friend just made their first purchase, and now you’ve earned a {{reward}} discount off your next order, valid until {{boosterExpiryDate}}"
        values={{
          reward: formatDiscountValue(discount),
          boosterExpiryDate: formatDate(calculateBoosterEndDate(campaign)),
        }}
      />
    </Typography>
    <Typography fontSize={14} fontWeight={700}>
      <Trans
        i18nKey="campaigns.boosters.referral.widget.congrats.reward"
        defaults="Enjoy your savings on orders over {{minPurchaseValue, currency}}!"
        values={{
          minPurchaseValue: discount.cashbackConfig.minRedemptionValue,
        }}
      />
    </Typography>
  </Stack>
);

export default ReferrerCongrats;
